import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import products from './Product';
import '../styles/ProductDetail.css'
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import prototypeimg from '../assest/Prototype Thumbnail.png'
const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id.toString() === id);

  if (!product) {
    return <h2>Product not found</h2>;
  }

  return (
    <>
      <div className='full-bg'>
        <div className="product-detail-wrapper">
          <h2>{product.name}</h2>
          <p>{product.mission}</p>
          <div className='product-detail-container' >

           <Link to={"/coming-soon"}> <div className='prototype-box'>
              <div className='prototype-img-container'>
                {/* <ReactPlayer
                  url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                  controls={true}

                  width="100%"
                  height="80%"

                  className="video-player"
                /> */}
       <img src={prototypeimg}/>
              </div>
              <h2>{product.prototypename1}</h2>

              <p>{product.paragraph} </p>
            </div></Link>

       <Link to={"/coming-soon"}>      <div className='prototype-box2'>
              <div className='prototype2-video-container'>
                {/* <ReactPlayer
                  url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                  controls={true}

                  width="100%"
                  height="80%"

                  className="video-player"
                /> */}
       <img src={prototypeimg}/>
              </div>
              <h2>{product.prototypename2}</h2>

              <p>{product.paragraph} </p>
            </div>
            </Link>
        <Link to={"/coming-soon"}>   <div className='prototype-box3'>
              <div className='prototype-video-container3'>
                {/* <ReactPlayer
                  url="https://youtu.be/KJwYBJMSbPI?si=WcogdokoILZyrLiV"
                  controls={true}

                  width="100%"
                  height="80%"

                  className="video-player"
                /> */}
                 <img src={prototypeimg}/>

              </div>

              <h2>{product.prototypename3}</h2>
              <p>{product.paragraph} </p>
            </div>

          </Link>  
          </div>
          <div className="button-container">
            <button
              className="all-solution-btn"
              onClick={() => navigate('/', { state: { scrollTo: 'contact' } })}
            >
              Contact Us &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
            {/* <a href="/product/Healthcare">healthcare</a> */}
            <button
              className="solution-btn1"
              onClick={() => navigate('/', { state: { scrollTo: 'gallery' } })}
            >
              Solution gallery &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
          </div>
          <h2 className='more-solution-h2'> Explore our more solutions</h2>
          <div className="button-container2">


          <Link to="/product/Healthcare">Healthcare Solution</Link>
<Link to="/product/Education">Education Solution</Link>
<Link to="/product/Retail">Retail Solution</Link>
<Link to="/product/Professionals">Professionals Solution</Link>
<Link to="/product/Startups">Startups Solution</Link>

            {/* <button
              className="more-solution-btn"
              onClick={() => navigate('/product/Healthcare',)}
            >
              HealthCare &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
            <button
              className="more-solution-btn"
              onClick={() => navigate('/product/Education')}
            >
              Education &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
            <button
              className="more-solution-btn"
              onClick={() => navigate('/product/Retail')}
            >
              Retail &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
            <button
              className="more-solution-btn"
              onClick={() => navigate('/product/Professionals')}
            >
              Professionals &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
            <button
              className="more-solution-btn"
              onClick={() => navigate('/product/Startups')}
            >
              Startups &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button> */}
          </div>
        </div>

      </div>

    </>
  );
};

export default ProductDetail;
